import {DropdownInput, generateOptionsFromSchema} from 'apstra-ui-common';
import {map} from 'lodash';
import {ComponentProps, FC, useMemo} from 'react';
import {Icon, Popup} from 'semantic-ui-react';

import {AGGREGATION_TYPE_UNSET} from '../consts';

// TODO: Merge with DropdownInputProps / DropdownControlProps when available
type AggregationTypeInputProps = ComponentProps<typeof DropdownInput>;

const AggregationTypeInput: FC<AggregationTypeInputProps> = ({value, onChange, schema, ...props}) => {
  const options = useMemo(() => map(
    generateOptionsFromSchema(schema),
    (item) => item.value === 'none' ?
      {
        ...item,
        icon: (
          <Popup
            content='No aggregation could result in performance issues.'
            position='left center'
            size='tiny'
            trigger={<Icon name='warning sign' color='yellow' />}
          />
        )
      } :
      item
  ), [schema]);

  return (
    <DropdownInput
      placeholder='Default aggregation'
      value={value === AGGREGATION_TYPE_UNSET ? '' : value}
      onChange={(aggregationType) => {
        onChange(aggregationType || AGGREGATION_TYPE_UNSET);
      }}
      {...props}
      options={options}
    />
  );
};

export default AggregationTypeInput;
